"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PaysafeBridge = _interopRequireDefault(require("./PaysafeBridge"));
var _PaymillBridge = _interopRequireDefault(require("./PaymillBridge"));
var _CheckoutBridge = _interopRequireDefault(require("./CheckoutBridge"));
var _newComponents = require("./new-components");
var _booking = require("./helpers/booking");
var _PaymentResponseMessage = _interopRequireDefault(require("./PaymentResponseMessage"));
var _envConstants = require("./env-constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PaymentBridge = /*#__PURE__*/function (_PureComponent) {
  function PaymentBridge(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, PaymentBridge);
    _this = _callSuper(this, PaymentBridge, [props]);
    _this.state = {
      error: undefined,
      paying: false,
      paymentConfig: null
    };
    _this.processToken = _this.processToken.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.onError = _this.onError.bind(_this);
    _this.getPaymentProviderConfig = _this.getPaymentProviderConfig.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(PaymentBridge, _PureComponent);
  return (0, _createClass2["default"])(PaymentBridge, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._mounted = true;
      var companyId = this.props.companyId;
      // payment config API so far implemented only on TYW so using fallback here
      if (_envConstants.ENV.SITE !== 'tyw') {
        this.setState({
          paymentConfig: window.etv
        });
      } else {
        this.getPaymentProviderConfig(companyId);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._mounted = false;
    }
  }, {
    key: "onSubmit",
    value: function onSubmit() {
      this.setState({
        error: undefined,
        payment: undefined
      });
    }
  }, {
    key: "onError",
    value: function onError(error) {
      if (this.props.bookingId) {
        (0, _booking.addBookingComment)(this.props.bookingId, JSON.stringify(error));
      }
      if (this.props.onError) {
        this.props.onError(error);
      }
    }
  }, {
    key: "getPaymentProviderConfig",
    value: function getPaymentProviderConfig(companyId) {
      var _this2 = this;
      fetch("/api/payment/config/".concat(companyId || ''), {
        credentials: 'same-origin'
      }).then(function (response) {
        return response.json();
      }).then(function (_ref) {
        var data = _ref.data;
        return _this2.setState({
          paymentConfig: data
        });
      })["catch"](function (ex) {
        return console.log('failed fetching payment provider config...', ex);
      });
    }
  }, {
    key: "processToken",
    value: function () {
      var _processToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(token, cardHolder, scheme, cardType, billingCountry) {
        var paymentConfig, _this$props, createPayment, orderId, currency, registeredAmount, service, onPaymentSuccess, _this$props$scheduled, scheduledPayments, activePaymentOption, useThreeDs, paymentConfigService, apiService, isCreatingScheduledPayments, paymentResult, payment, error;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              paymentConfig = this.state.paymentConfig;
              _this$props = this.props, createPayment = _this$props.createPayment, orderId = _this$props.orderId, currency = _this$props.currency, registeredAmount = _this$props.registeredAmount, service = _this$props.service, onPaymentSuccess = _this$props.onPaymentSuccess, _this$props$scheduled = _this$props.scheduledPayments, scheduledPayments = _this$props$scheduled === void 0 ? [] : _this$props$scheduled, activePaymentOption = _this$props.activePaymentOption;
              useThreeDs = true;
              if (window.location.search.indexOf('skip3ds') > -1) {
                useThreeDs = false;
              }
              this.setState({
                paying: true,
                error: undefined,
                payment: undefined
              });
              paymentConfigService = paymentConfig && paymentConfig.paymentProviders && paymentConfig.paymentProviders[paymentConfig.defaultPaymentProvider] && paymentConfig.paymentProviders[paymentConfig.defaultPaymentProvider].service; // 1. check if we manually pass service in props
              // 2. try to get service name from payment config api
              // 3. just get default payment provider if all above fail (tsw, qd)
              apiService = service || paymentConfigService || paymentConfig.defaultPaymentProvider;
              isCreatingScheduledPayments = !!scheduledPayments.length;
              _context.next = 10;
              return createPayment(orderId, registeredAmount, token, currency, apiService, cardHolder, scheme, useThreeDs, isCreatingScheduledPayments, activePaymentOption, cardType, billingCountry, this.props.isScheduledPaymentsUpdate);
            case 10:
              paymentResult = _context.sent;
              payment = paymentResult.data;
              error = paymentResult.error;
              if ((payment === null || payment === void 0 ? void 0 : payment.status) === 'paid') {
                onPaymentSuccess(payment);
              }
              if (this._mounted) {
                this.setState({
                  payment: payment,
                  error: error,
                  paying: false
                });
              }
              return _context.abrupt("return", payment);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function processToken(_x, _x2, _x3, _x4, _x5) {
        return _processToken.apply(this, arguments);
      }
      return processToken;
    }()
  }, {
    key: "renderPaymentGate",
    value: function renderPaymentGate() {
      var _this$props2 = this.props,
        registeredAmount = _this$props2.registeredAmount,
        paidAmount = _this$props2.paidAmount,
        amountString = _this$props2.amountString,
        currency = _this$props2.currency,
        email = _this$props2.email,
        service = _this$props2.service,
        visa = _this$props2.visa,
        mastercard = _this$props2.mastercard,
        amex = _this$props2.amex,
        guys = _this$props2.guys,
        girls = _this$props2.girls,
        product = _this$props2.product,
        baseUrl = _this$props2.baseUrl,
        minAge = _this$props2.minAge,
        orderId = _this$props2.orderId,
        onPaymentSuccess = _this$props2.onPaymentSuccess,
        checkPaymentInfo = _this$props2.checkPaymentInfo,
        canCancelBooking = _this$props2.canCancelBooking,
        disableWalletPayments = _this$props2.disableWalletPayments,
        companyId = _this$props2.companyId,
        weekTerms = _this$props2.weekTerms,
        destinationId = _this$props2.destinationId,
        _this$props2$schedule = _this$props2.scheduledPayments,
        scheduledPayments = _this$props2$schedule === void 0 ? [] : _this$props2$schedule,
        travelInsuranceCheckBox = _this$props2.travelInsuranceCheckBox,
        isBookingUkBased = _this$props2.isBookingUkBased,
        skipCardCharges = _this$props2.skipCardCharges,
        hasPromoCodeApplied = _this$props2.hasPromoCodeApplied,
        isScheduledPaymentsUpdate = _this$props2.isScheduledPaymentsUpdate;
      var _this$state = this.state,
        paying = _this$state.paying,
        paymentConfig = _this$state.paymentConfig;
      if (!paymentConfig) {
        return null;
      }
      var apiService = service || paymentConfig.defaultPaymentProvider;
      var props = _objectSpread(_objectSpread(_objectSpread({
        registeredAmount: registeredAmount,
        paidAmount: paidAmount,
        amountString: amountString,
        onSuccess: this.processToken,
        onSubmit: this.onSubmit,
        checkPaymentInfo: checkPaymentInfo,
        onPaymentSuccess: onPaymentSuccess,
        processing: paying,
        currency: currency,
        email: email
      }, paymentConfig), paymentConfig && paymentConfig.paymentProviders[apiService]), {}, {
        onError: this.onError,
        visa: visa,
        mastercard: mastercard,
        amex: amex,
        guys: guys,
        girls: girls,
        product: product,
        baseUrl: baseUrl,
        minAge: minAge,
        orderId: orderId,
        canCancelBooking: canCancelBooking,
        disableWalletPayments: disableWalletPayments,
        companyId: companyId,
        weekTerms: weekTerms,
        destinationId: destinationId,
        scheduledPayments: scheduledPayments,
        travelInsuranceCheckBox: travelInsuranceCheckBox,
        isBookingUkBased: isBookingUkBased,
        skipCardCharges: skipCardCharges,
        hasPromoCodeApplied: hasPromoCodeApplied,
        isScheduledPaymentsUpdate: isScheduledPaymentsUpdate
      });
      switch (apiService) {
        case 'paysafe':
          return /*#__PURE__*/_react["default"].createElement(_PaysafeBridge["default"], props);
        case 'paymill':
          return /*#__PURE__*/_react["default"].createElement(_PaymillBridge["default"], props);
        case 'checkout':
          return /*#__PURE__*/_react["default"].createElement(_CheckoutBridge["default"], props);
        default:
          console.error("Payment service '".concat(apiService, "' is not implemented."));
          return /*#__PURE__*/_react["default"].createElement(_newComponents.Alert, {
            type: "error",
            text: "Payment service is not available at the moment, please try again later"
          });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
        error = _this$state2.error,
        payment = _this$state2.payment;
      return /*#__PURE__*/_react["default"].createElement("div", null, this.renderPaymentGate(), error && /*#__PURE__*/_react["default"].createElement("h2", {
        style: {
          color: 'red'
        }
      }, error.message), payment && /*#__PURE__*/_react["default"].createElement(_PaymentResponseMessage["default"], {
        payment: payment
      }));
    }
  }]);
}(_react.PureComponent);
PaymentBridge.propTypes = {
  bookingId: _propTypes["default"].number,
  orderId: _propTypes["default"].number.isRequired,
  registeredAmount: _propTypes["default"].number.isRequired,
  paidAmount: _propTypes["default"].number.isRequired,
  currency: _propTypes["default"].string.isRequired,
  email: _propTypes["default"].string,
  amountString: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired,
  service: _propTypes["default"].string,
  createPayment: _propTypes["default"].func.isRequired,
  checkPaymentInfo: _propTypes["default"].func,
  onPaymentSuccess: _propTypes["default"].func.isRequired,
  onError: _propTypes["default"].func,
  amex: _propTypes["default"].bool,
  visa: _propTypes["default"].bool,
  mastercard: _propTypes["default"].bool,
  girls: _propTypes["default"].string,
  guys: _propTypes["default"].string,
  product: _propTypes["default"].string,
  baseUrl: _propTypes["default"].string,
  minAge: _propTypes["default"].number,
  canCancelBooking: _propTypes["default"].bool,
  disableWalletPayments: _propTypes["default"].bool,
  companyId: _propTypes["default"].number,
  destinationId: _propTypes["default"].number,
  weekTerms: _propTypes["default"].string,
  travelInsuranceCheckBox: _propTypes["default"].bool,
  isBookingUkBased: _propTypes["default"].bool,
  scheduledPayments: _propTypes["default"].array,
  activePaymentOption: _propTypes["default"].string,
  skipCardCharges: _propTypes["default"].bool,
  hasPromoCodeApplied: _propTypes["default"].bool,
  isScheduledPaymentsUpdate: _propTypes["default"].bool
};
var _default = exports["default"] = PaymentBridge;